import { ThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import App from '../App/App';
import store from '../App/redux/store';
import mainTheme from '../themes/mainTheme';

function RootLayout() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={mainTheme}>
        <App />
      </ThemeProvider>
    </Provider>
  );
}

export default RootLayout;
